// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.todo sup {\n  background: none;\n  position: absolute !important;\n  top: 10px !important;\n  color: red;\n  height: 0;\n  line-height: 0;\n  border: none;\n  padding-left: 10px;\n}\n.done sup {\n  background: none;\n  position: absolute !important;\n  top: 10px !important;\n  color: #0d980d;\n  height: 0;\n  line-height: 0;\n  border: none;\n  padding-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
